"use client";

import { Core } from "@faire/slate/foundation/color";
import React from "react";

import { createSVGIcon } from "../lib/iconUtils";

// TODO(alipianu): sync from Figma
/**
 * @trackcomponent
 * @figma designed by Nick Howland (see [Figma](https://figma.com/file/qcB5qVN7uKBBYHN49ihDE7?node-id=7%3A349))
 * @lastsynced 2025-07-07T19:22:53.646Z
 * @optimized using svgo:^3.0.2
 */
export const ChevronDown = createSVGIcon(
  <path
    d="m2 7 9.455 9.767A.77.77 0 0 0 12 17a.75.75 0 0 0 .545-.233L22 7"
    stroke="currentColor"
    strokeLinecap="round"
    strokeLinejoin="round"
  />,
  "ChevronDown",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    color: Core.icon.primary,
  } // This icon is decorative, keep titleAccess empty so it doesn't clutter the screenreader experience
);
